import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";

import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import { trackPromise } from "react-promise-tracker";
import services from "../../../../services";
import { useSnackBar } from "../../../../hooks/snackBar";

import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";

import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";

import {
  uploadImagemProduto,
  cadastrarProdutoSeller,
  detalheProdutoSeller,
  buscarDadosProdutoSeller,
  editarProdutoSeller,
  inativarProdutoSeller,
  ativarProdutoSeller,
  atualizarProdutoIntegracao,
  buscarDadosProdutoSellerGtin,
  excluirProdutoSeller,
  verificarEanSeller,
} from "../../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService";

import EmptyImage from "../../../../assets/img/emptyImage.PNG";

import "./styles.scss";
import { Formik } from "formik";
import { estados } from "../../../../services/estadosBrasil";
import { Autocomplete, MenuItem, Select } from "@mui/material";
import { empresasSellerTodos } from "../../../../services/http/sellerService";
import Modal from "../../../../components/Modal";
import ButtonYesNo from "../../../../components/ButtonYesNo";

const PerfilSellerProdutoForm = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const { idSeller } = services.storage.getUser();
  const { id } = useParams();
  const [idProdutoApiSeller, setIdProdutoApiSeller] = useState(null);
  const [isFormInvalid, setIsFormInvalid] = useState(false);
  const [voltou, setVoltou] = useState(false);
  const [mainState, setMainState] = useState("initial"); // initial, uploaded
  const [imageUploaded, setImageUploaded] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [idProdutoSeller, setIdProdutoSeller] = useState(null);
  const [file, setFile] = useState(null);
  const [dadosEncontradosPorGtin, setBuscaPorGtin] = useState(null);
  const stateRef = useRef();
  const { idEmpresa } = useParams();
  const [novoProduto, setNovoProduto] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [propertyBeingChanged, setPropertyBeingChanged] = useState(null);
  const [atualizarProduto, setAtualizarProduto] = useState(false);
  const [camposNulosIntegracaoSimplus, setCamposNulosIntegracaoSimplus] =
    useState(null);
  const [modal, setModal] = useState(false);
  const [modalVerificacaoEanSeller, setModalVerificacaoEanSeller] =
    useState(false);

  stateRef.current = voltou;

  const [produtoSeller, setProdutoSeller] = useState({
    gtin: "",
    nomeProduto: "",
    gpc: "",
    sku: "",
    categoria: "",
    ncm: "",
    descricaoProduto: "",
    produtoUrlImagem: "",
    paisRegistro: "",
    fabricante: "",
    distribuidores: "",
    marca: "",
    precoMedio: 0,
    descricaoNcm: "",
    dataAtualizacao: "",
    validade: "",
    quantidadeUnidade: "",
    alturaUnidade: "",
    larguraUnidade: "",
    profundidadeUnidade: "",
    pesoBrutoUnidade: "",
    pesoLiquidoUnidade: "",
    volumeUnidade: "",
    gtinDun14Caixa: "",
    quantidadePorCaixa: "",
    alturaCaixa: "",
    larguraCaixa: "",
    profundidadeCaixa: "",
    volumeCaixa: "",
    pesoBrutoCaixa: "",
    pesoLiquidoCaixa: "",
    quantidadeDeCaixaPorPallet: "",
    alturaPallet: "",
    larguraPallet: "",
    profundidadePallet: "",
    pesoBrutoPallet: "",
    pesoLiquidoPallet: "",
    volumePallet: "",
    sellerId: "",
  });

  const handleUploadClick = (event) => {
    var file = event.target.files[0];
    setFile(file);
    const reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setSelectedFile([reader.result]);
    };

    setMainState("uploaded");
    setSelectedFile(event.target.files[0]);
    setImageUploaded(1);
  };

  useEffect(() => {
    if (id != null) {
      CarregarDetalhesProdutoSeller(id);
      setIdProdutoSeller(id);

      //if(produtoSeller.ncm == '')
      //    setHabilitaNCM(false);
    }
    CarregarListaSellers();
  }, []);

  /* useEffect(() => {
        //changesProduto(event.target.value, 'gtin')
        if (novoProduto == false) {

            if (produtoSeller.nomeProduto == null || produtoSeller.nomeProduto == '') { changesProduto('Não se aplica', 'nomeProduto') };
            if (produtoSeller.gpc == null || produtoSeller.gpc == '') { changesProduto('Não se aplica', 'gpc') };
            if (produtoSeller.categoria == null || produtoSeller.categoria == '') { changesProduto('Não se aplica', 'categoria') };
            if (produtoSeller.ncm == null || produtoSeller.ncm == '') { changesProduto('Não se aplica', 'ncm') };
            if (produtoSeller.descricaoProduto == null || produtoSeller.descricaoProduto == '') { changesProduto('Não se aplica', 'descricaoProduto') };
            //if(produtoSeller.produtoUrlImagem== null || produtoSeller.nomeProduto == ''){ changesProduto('Não se aplica', 'nomeProduto') };
            if (produtoSeller.paisRegistro == null || produtoSeller.paisRegistro == '') { changesProduto('Não se aplica', 'paisRegistro') };
            if (produtoSeller.fabricante == null || produtoSeller.fabricante == '') { changesProduto('Não se aplica', 'fabricante') };
            if (produtoSeller.distribuidores == null || produtoSeller.distribuidores == '') { changesProduto('Não se aplica', 'distribuidores') };
            if (produtoSeller.marca == null || produtoSeller.marca == '') { changesProduto('Não se aplica', 'marca') };
            //if(produtoSeller.precoMedio: 0,
            if (produtoSeller.descricaoNcm == null || produtoSeller.descricaoNcm == '') { changesProduto('Não se aplica', 'descricaoNcm') };
            if (produtoSeller.validade == null || produtoSeller.validade == '') { changesProduto('Não se aplica', 'validade') };
            if (produtoSeller.quantidadeUnidade == null || produtoSeller.quantidadeUnidade == '') { changesProduto('Não se aplica', 'quantidadeUnidade') };
            if (produtoSeller.alturaUnidade == null || produtoSeller.alturaUnidade == '') { changesProduto('Não se aplica', 'alturaUnidade') };
            if (produtoSeller.larguraUnidade == null || produtoSeller.larguraUnidade == '') { changesProduto('Não se aplica', 'larguraUnidade') };
            if (produtoSeller.profundidadeUnidade == null || produtoSeller.profundidadeUnidade == '') { changesProduto('Não se aplica', 'profundidadeUnidade') };
            if (produtoSeller.pesoBrutoUnidade == null || produtoSeller.pesoBrutoUnidade == '') { changesProduto('Não se aplica', 'pesoBrutoUnidade') };
            if (produtoSeller.pesoLiquidoUnidade == null || produtoSeller.pesoLiquidoUnidade == '') { changesProduto('Não se aplica', 'pesoLiquidoUnidade') };
            if (produtoSeller.volumeUnidade == null || produtoSeller.volumeUnidade == '') { changesProduto('Não se aplica', 'volumeUnidade') };
            if (produtoSeller.gtinDun14Caixa == null || produtoSeller.gtinDun14Caixa == '') { changesProduto('Não se aplica', 'gtinDun14Caixa') };
            if (produtoSeller.quantidadePorCaixa == null || produtoSeller.quantidadePorCaixa == '') { changesProduto('Não se aplica', 'quantidadePorCaixa') };
            if (produtoSeller.alturaCaixa == null || produtoSeller.alturaCaixa == '') { changesProduto('Não se aplica', 'alturaCaixa') };
            if (produtoSeller.larguraCaixa == null || produtoSeller.larguraCaixa == '') { changesProduto('Não se aplica', 'larguraCaixa') };
            if (produtoSeller.profundidadeCaixa == null || produtoSeller.profundidadeCaixa == '') { changesProduto('Não se aplica', 'profundidadeCaixa') };
            if (produtoSeller.volumeCaixa == null || produtoSeller.volumeCaixa == '') { changesProduto('Não se aplica', 'volumeCaixa') };
            if (produtoSeller.pesoBrutoCaixa == null || produtoSeller.pesoBrutoCaixa == '') { changesProduto('Não se aplica', 'pesoBrutoCaixa') };
            if (produtoSeller.pesoLiquidoCaixa == null || produtoSeller.pesoLiquidoCaixa == '') { changesProduto('Não se aplica', 'pesoLiquidoCaixa') };
            if (produtoSeller.quantidadeDeCaixaPorPallet == null || produtoSeller.quantidadeDeCaixaPorPallet == '') { changesProduto('Não se aplica', 'quantidadeDeCaixaPorPallet') };
            if (produtoSeller.alturaPallet == null || produtoSeller.alturaPallet == '') { changesProduto('Não se aplica', 'alturaPallet') };
            if (produtoSeller.larguraPallet == null || produtoSeller.larguraPallet == '') { changesProduto('Não se aplica', 'larguraPallet') };
            if (produtoSeller.profundidadePallet == null || produtoSeller.profundidadePallet == '') { changesProduto('Não se aplica', 'profundidadePallet') };
            if (produtoSeller.pesoBrutoPallet == null || produtoSeller.pesoBrutoPallet == '') { changesProduto('Não se aplica', 'pesoBrutoPallet') };
            if (produtoSeller.pesoLiquidoPallet == null || produtoSeller.pesoLiquidoPallet == '') { changesProduto('Não se aplica', 'pesoLiquidoPallet') };
            if (produtoSeller.volumePallet == null || produtoSeller.volumePallet == '') { changesProduto('Não se aplica', 'volumePallet') };
        }


    }, [produtoSeller]); */

  const voltar = () => {
    history.push("/produto");
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  const CarregarDetalhesProdutoSeller = (id, imagemAtual) => {
    setNovoProduto(false);
    trackPromise(
      detalheProdutoSeller(id)
        .then((res) => {
          if (res.data) {
            console.log(imagemAtual == undefined);
            console.log(res.data?.dadosEmpresaSeller);

            // Primeiro, atualiza o produtoSeller com os dados da resposta
            const produtoAtualizado = {
              ...res.data,
              // Mantém o produtoUrlImagem original se imagemAtual for undefined
              // Caso contrário, usa o imagemAtual
              produtoUrlImagem:
                imagemAtual !== undefined
                  ? imagemAtual
                  : res.data.produtoUrlImagem,
            };

            setProdutoSeller((prev) => ({
              ...prev,
              sellerId: res.data?.dadosEmpresaSeller?.id,
            }));

            // Agora seta o produto completo com a imagem atualizada (se necessário)
            setProdutoSeller(produtoAtualizado);

            CarregarListaSellers(res.data?.dadosEmpresaSeller?.id);
          } else {
            if (id) {
              addSnackBar({
                message: "Não foi possível carregar detalhes do produto",
                info: "warning",
                open: true,
              });
            }
          }
        })
        .catch((error) => {
          addSnackBar({
            message: "Erro ao tentar obter detalhes do produto",
            info: "error",
            open: true,
          });
        })
    );
  };
  const CarregarListaSellers = (id) => {
    trackPromise(
      empresasSellerTodos().then((res) => {
        if (res.data) {
          setEmpresas(res.data);
        
          // Se a lista de empresas foi carregada, tente definir o sellerId se ele já estiver presente
          const sellerAtual = res.data.find((s) => s.id === id);
          if (sellerAtual) {
            setProdutoSeller((prev) => ({
              ...prev,
              sellerId: sellerAtual.id,
            }));
          }
        } else {
          addSnackBar({
            message: "Não foi possível carregar sellers",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ao tentar carregar sellers",
        info: "error",
        open: true,
      });
    });
  };
  const fnVerificarEanSeller = async (idEmpresa, gtin, sku) => {
    setNovoProduto(false);
    try {
      const res = await trackPromise(verificarEanSeller(idEmpresa, gtin, sku));

      if (res.data.exists) {
        setIdProdutoApiSeller(res.data.produtoId);
        setModalVerificacaoEanSeller(true);
      } else {
        uploadImagem();
      }
    } catch (error) {
      setModalVerificacaoEanSeller(true);
    }
  };

  const uploadImagem = (idP = null) => {
    //alert(produtoSeller?.produtoUrlImagem);
    //alert(file);
    //var fileInternal = file;
    //console.log(produtoSeller?.produtoUrlImagem);
    //if(produtoSeller?.produtoUrlImagem != null && produtoSeller?.produtoUrlImagem !='' && (fileInternal==null||fileInternal==undefined) ){
    //    fileInternal = produtoSeller?.produtoUrlImagem;
    //}

    if (file != null && file != undefined) {
      trackPromise(
        uploadImagemProduto(file).then((res) => {
          if (res.data) {
            changesProduto(res.data, "produtoUrlImagem");
            submitProdutoSeller(res.data, idP);
          } else {
            addSnackBar({
              message: "Não foi possível extrair a base com produtos",
              info: "warning",
              open: true,
            });
          }
        })
      ).catch((error) => {
        addSnackBar({
          message: "Erro ao fazer upload da imagem do produto",
          info: "error",
          open: true,
        });
      });
    } else {
      //alert('parte do submit commum');
      submitProdutoSeller(produtoSeller?.produtoUrlImagem, idP);
    }
  };

  // alterar forma de validação para yup
  const validarForm = () => {
    var isInvalidForm = false;
    if (!produtoSeller.gtin) isInvalidForm = true;

    setIsFormInvalid(isInvalidForm);

    return isInvalidForm;
  };
  const [isFormValid, setIsFormValid] = useState(false);

  // Função para validar os campos
  const validateForm = () => {
    if (produtoSeller?.gtin && produtoSeller?.sellerId) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };
  useEffect(() => {
    validateForm();
    console.log(produtoSeller);
  }, [produtoSeller?.gtin, produtoSeller?.sku, produtoSeller?.sellerId]);

  const inativarProduto = () => {
    if (id != undefined) {
      trackPromise(
        inativarProdutoSeller(id)
          .then((res) => {
            if (res.data) {
              addSnackBar({
                message: "produto inativado com sucesso",
                info: "success",
                open: true,
              });
              voltar(3);
            } else {
              addSnackBar({
                message: "Não foi inativar produto",
                info: "warning",
                open: true,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            addSnackBar({
              message: "Erro ao inativar produto",
              info: "error",
              open: true,
            });
          })
      );
    }
  };

  const changesSeller = (value, propertie) => {
    setProdutoSeller((produto) => ({
      ...produto,
      [propertie]: value,
    }));
  };

  const ativarProduto = () => {
    if (id != undefined) {
      trackPromise(
        ativarProdutoSeller(id)
          .then((res) => {
            if (res.data) {
              addSnackBar({
                message: "produto ativado com sucesso",
                info: "success",
                open: true,
              });
              voltar(3);
            } else {
              res.errors.forEach((element) => {
                addSnackBar({
                  message: element.mensagem,
                  info: "warning",
                  open: true,
                });
              });
            }
          })
          .catch((error) => {
            console.log(error);
            addSnackBar({
              message: "Erro ao inativar produto",
              info: "error",
              open: true,
            });
          })
      );
    }
  };

  const excluirProduto = () => {
    if (id != undefined) {
      trackPromise(
        excluirProdutoSeller(id)
          .then((res) => {
            addSnackBar({
              message: "Produto excluído com sucesso",
              info: "success",
              open: true,
            });
            history.push("/produto");
          })
          .catch((error) => {
            console.log(error);
            addSnackBar({
              message: "Erro ao excluir produto",
              info: "error",
              open: true,
            });
          })
      );
    }
  };

  const removerMascaraMoeda = (valor) => {
    if (!valor) return 0; // Retorna 0 se o valor for null, undefined ou falsy
    return parseFloat(
      String(valor)
        .replace(/[^\d,.-]/g, "")
        .replace(",", ".")
    );
  };

  const submitProdutoSeller = (urlImg = "", idP = null) => {
 
    if (!validarForm()) {
      // Remove máscara antes de salvar
      produtoSeller.precoMedio = removerMascaraMoeda(produtoSeller.precoMedio);

      if (urlImg != "") {
        produtoSeller.produtoUrlImagem = urlImg;
      }

      if (
        (idP == null && id == null) ||
        (idP == undefined && id == undefined)
      ) {
 
        trackPromise(
          cadastrarProdutoSeller(produtoSeller, produtoSeller?.sellerId)
            .then((res) => {
              if (res.data) {
                addSnackBar({
                  message: "Cadastrado com sucesso",
                  info: "success",
                  open: true,
                });
                setIdProdutoSeller(res.data);
                voltar(3);
              } else {
                res.errors.forEach((element) => {
                  addSnackBar({
                    message: element.menssagem,
                    info: "warning",
                    open: true,
                  });
                });
              }
            })
            .catch((error) => {
              console.log(error);
              addSnackBar({
                message: "Erro ao cadastrar produto",
                info: "error",
                open: true,
              });
            })
        );
      } else {
        produtoSeller.id = id || idP; 
        trackPromise(
          editarProdutoSeller(produtoSeller)
            .then((res) => {
              if (res.fail == null) {
                addSnackBar({
                  message: "Produto atualizado com sucesso",
                  info: "success",
                  open: true,
                });
                voltar(3);
              } else {
                addSnackBar({
                  message: "Não foi possível editar produto",
                  info: "error",
                  open: true,
                });
              }
            })
            .catch((error) => {
              console.log(error);
              addSnackBar({
                message: "Erro ao editar produto",
                info: "error",
                open: true,
              });
            })
        );
      }
    }
  };

  const showEmptyImage = () => {
    if (imageUploaded == 0 && produtoSeller.produtoUrlImagem == "") {
      return (
        <div className="d-flex justify-content-center empty-image">
          <img className="image" src={EmptyImage} />
        </div>
      );
    }
  };

  const atribuirValoresDaAtualizacao = (data) => {
    console.log(data, "arozzzz");
    setProdutoSeller((prevent) => ({
      ...prevent,
      gtin: data?.gtin ?? prevent.gtin,
      nomeProduto:
        data?.nomeProduto != "" ? data?.nomeProduto : prevent.nomeProduto,
      gpc: data?.gpc ?? prevent.gpc,
      sku: data?.sku ?? prevent.sku,
      categoria: data?.categoria ?? prevent.categoria,
      ncm: data?.ncm ?? prevent.ncm,
      dataAtualizacao: data?.dataAtualizacao ?? prevent.dataAtualizacao,
      descricaoProduto: data?.descricaoProduto ?? prevent.descricaoProduto,
      produtoUrlImagem: data?.produtoUrlImagem ?? prevent.produtoUrlImagem,
      paisRegistro: data?.paisRegistro ?? prevent.paisRegistro,
      fabricante: data?.fabricante ?? prevent.fabricante,
      distribuidores: data?.distribuidores ?? prevent.distribuidores,
      marca: data?.marca ?? prevent.marca,
      precoMedio: data?.precoMedio ?? prevent.precoMedio,
      descricaoNcm: data?.descricaoNcm ?? prevent.descricaoNcm,
      validade: data?.validade ?? prevent.validade,
      quantidadeUnidade: data?.quantidadeUnidade ?? prevent.quantidadeUnidade,
      alturaUnidade: data?.alturaUnidade ?? prevent.alturaUnidade,
      larguraUnidade: data?.larguraUnidade ?? prevent.larguraUnidade,
      profundidadeUnidade:
        data?.profundidadeUnidade ?? prevent.profundidadeUnidade,
      pesoBrutoUnidade: data?.pesoBrutoUnidade ?? prevent.pesoBrutoUnidade,
      pesoLiquidoUnidade:
        data?.pesoLiquidoUnidade ?? prevent.pesoLiquidoUnidade,
      volumeUnidade: data?.volumeUnidade ?? prevent.volumeUnidade,
      gtinDun14Caixa: data?.gtinDun14Caixa ?? prevent.gtinDun14Caixa,
      quantidadePorCaixa:
        data?.quantidadePorCaixa ?? prevent.quantidadePorCaixa,
      alturaCaixa: data?.alturaCaixa ?? prevent.alturaCaixa,
      larguraCaixa: data?.larguraCaixa ?? prevent.larguraCaixa,
      profundidadeCaixa: data?.profundidadeCaixa ?? prevent.profundidadeCaixa,
      volumeCaixa: data?.volumeCaixa ?? prevent.volumeCaixa,
      pesoBrutoCaixa: data?.pesoBrutoCaixa ?? prevent.pesoBrutoCaixa,
      pesoLiquidoCaixa: data?.pesoLiquidoCaixa ?? prevent.pesoLiquidoCaixa,
      quantidadeDeCaixaPorPallet:
        data?.quantidadeDeCaixaPorPallet ?? prevent.quantidadeDeCaixaPorPallet,
      alturaPallet: data?.alturaPallet ?? prevent.alturaPallet,
      larguraPallet: data?.larguraPallet ?? prevent.larguraPallet,
      profundidadePallet:
        data?.profundidadePallet ?? prevent.profundidadePallet,
      pesoBrutoPallet: data?.pesoBrutoPallet ?? prevent.pesoBrutoPallet,
      pesoLiquidoPallet: data?.pesoLiquidoPallet ?? prevent.pesoLiquidoPallet,
      volumePallet: data?.volumePallet ?? prevent.volumePallet,
    }));
  };

  const atualizarProdutoSimplus = () => {
    trackPromise(
      atualizarProdutoIntegracao(produtoSeller.gtin)
        .then((res) => {
          if (res.data) {
            setBuscaPorGtin(true);
            setAtualizarProduto(true);
            validarCampoNaoSeAplica(res.data);
            setCamposNulosIntegracaoSimplus(res.data);
            atribuirValoresDaAtualizacao(res.data);
          } else {
            setBuscaPorGtin(false);
            // O back agora devolve a mensagem real da Simplus (ex.: "Produto existe mas está inativo.").
            const mensagem =
              res?.errors?.[0]?.menssagem ||
              "Nenhum produto encontrado com o Gtin informado.";
            addSnackBar({
              message: mensagem,
              info: "warning",
              open: true,
            });
          }
        })
        .catch((error) => {
          addSnackBar({
            message: "Erro ao tentar obter detalhes do produto por Gtin",
            info: "error",
            open: true,
          });
          setBuscaPorGtin(false);
        })
    );
  };
  const formatarMoeda = (valor) => {
    if (!valor) return "";
    const numero = valor.replace(/[^\d]/g, ""); // Remove caracteres não numéricos
    const valorFormatado = (numero / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
    return valorFormatado.replace("R$", "").trim(); // Remove "R$" se necessário
  };

  const handleMascaraMoeda = (event, propertie) => {
    const valorFormatado = formatarMoeda(event.target.value);
    changesProduto(valorFormatado, propertie);
  };
  const changesProduto = (value, propertie) => {
    setPropertyBeingChanged(propertie);
    setProdutoSeller((prevent) => ({
      ...prevent,
      [propertie]: value,
    }));
  };

  const validarCampoNaoSeAplica = (data) => {
    if (data.distribuidores == "Não se Aplica!") data.distribuidores = null;
    if (data.nomeProduto == "Não se Aplica!") data.nomeProduto = null;
    if (data.gpc == "Não se Aplica!") data.gpc = null;
    if (data.sku == "Não se Aplica!") data.sku = null;
    if (data.categoria == "Não se Aplica!") data.categoria = null;
    if (data.ncm == "Não se Aplica!") data.ncm = null;
    if (data.descricaoProduto == "Não se Aplica!") data.descricaoProduto = null;
    if (data.paisRegistro == "Não se Aplica!") data.paisRegistro = null;
    if (data.fabricante == "Não se Aplica!") data.fabricante = null;
    if (data.distribuidores == "Não se Aplica!") data.distribuidores = null;
    if (data.marca == "Não se Aplica!") data.marca = null;
    if (data.descricaoNcm == "Não se Aplica!") data.descricaoNcm = null;
    if (data.validade == "Não se Aplica!") data.validade = null;
    if (data.quantidadeUnidade == "Não se Aplica!")
      data.quantidadeUnidade = null;
    if (data.alturaUnidade == "Não se Aplica!") data.alturaUnidade = null;
    if (data.larguraUnidade == "Não se Aplica!") data.larguraUnidade = null;
    if (data.profundidadeUnidade == "Não se Aplica!")
      data.profundidadeUnidade = null;
    if (data.pesoBrutoUnidade == "Não se Aplica!") data.pesoBrutoUnidade = null;
    if (data.pesoLiquidoUnidade == "Não se Aplica!")
      data.pesoLiquidoUnidade = null;
    if (data.volumeUnidade == "Não se Aplica!") data.volumeUnidade = null;
    if (data.gtinDun14Caixa == "Não se Aplica!") data.gtinDun14Caixa = null;
    if (data.quantidadePorCaixa == "Não se Aplica!")
      data.quantidadePorCaixa = null;
    if (data.alturaCaixa == "Não se Aplica!") data.alturaCaixa = null;
    if (data.larguraCaixa == "Não se Aplica!") data.larguraCaixa = null;
    if (data.profundidadeCaixa == "Não se Aplica!")
      data.profundidadeCaixa = null;
    if (data.volumeCaixa == "Não se Aplica!") data.volumeCaixa = null;
    if (data.pesoBrutoCaixa == "Não se Aplica!") data.pesoBrutoCaixa = null;
    if (data.pesoLiquidoCaixa == "Não se Aplica!") data.pesoLiquidoCaixa = null;
    if (data.quantidadeDeCaixaPorPallet == "Não se Aplica!")
      data.quantidadeDeCaixaPorPallet = null;
    if (data.alturaPallet == "Não se Aplica!") data.alturaPallet = null;
    if (data.larguraPallet == "Não se Aplica!") data.larguraPallet = null;
    if (data.profundidadePallet == "Não se Aplica!")
      data.profundidadePallet = null;
    if (data.pesoBrutoPallet == "Não se Aplica!") data.pesoBrutoPallet = null;
    if (data.pesoLiquidoPallet == "Não se Aplica!")
      data.pesoLiquidoPallet = null;
    if (data.volumePallet == "Não se Aplica!") data.volumePallet = null;
  };

  // const buscarDadosPorGtin = (event) => {
  //     let value = event.target.value;
  //     var filtroIdEmpresa = idEmpresa;
  //     //alert(value);
  //     var profile = services.storage.get('authSistema');
  //     if (idEmpresa == null || idEmpresa == undefined) {
  //         if (profile != null && profile.idSeller != null)
  //             filtroIdEmpresa = profile.idSeller;
  //     }
  //     //alert(JSON.stringify(profile));
  //     if (event.code === "Enter" || event.code === "NumpadEnter") {
  //         setNovoProduto(false);
  //         trackPromise(
  //             buscarDadosProdutoSeller(value, filtroIdEmpresa)
  //                 .then(res => {
  //                     //alert(JSON.stringify(res.data));
  //                     if (res.data) {
  //                         validarCampoNaoSeAplica(res.data)
  //                         setNovoProduto(false);
  //                         setBuscaPorGtin(true);
  //                         setProdutoSeller(res.data);
  //                     } else {
  //                         setNovoProduto(true);
  //                         //setHabilitaNCM(true);
  //                         setProdutoSeller({
  //                             gtin: value,
  //                             nomeProduto: "",
  //                             gpc: "",
  //                             sku:"",
  //                             sellerId:"",
  //                             categoria: "",
  //                             ncm: "",
  //                             descricaoProduto: "",
  //                             produtoUrlImagem: "",
  //                             paisRegistro: "",
  //                             fabricante: "",
  //                             distribuidores: "",
  //                             marca: "",
  //                             precoMedio: 0,
  //                             descricaoNcm: "",
  //                             validade: "",
  //                             quantidadeUnidade: "",
  //                             alturaUnidade: "",
  //                             larguraUnidade: "",
  //                             profundidadeUnidade: "",
  //                             pesoBrutoUnidade: "",
  //                             pesoLiquidoUnidade: "",
  //                             volumeUnidade: "",
  //                             gtinDun14Caixa: "",
  //                             quantidadePorCaixa: "",
  //                             alturaCaixa: "",
  //                             larguraCaixa: "",
  //                             profundidadeCaixa: "",
  //                             volumeCaixa: "",
  //                             pesoBrutoCaixa: "",
  //                             pesoLiquidoCaixa: "",
  //                             quantidadeDeCaixaPorPallet: "",
  //                             alturaPallet: "",
  //                             larguraPallet: "",
  //                             profundidadePallet: "",
  //                             pesoBrutoPallet: "",
  //                             pesoLiquidoPallet: "",
  //                             volumePallet: ""
  //                         });
  //                         /*  setProdutoSeller((prevent) => ({
  //                              ...prevent,
  //                              gtin: value
  //                          })); */
  //                         setBuscaPorGtin(false);
  //                         addSnackBar({ message: 'Nenhum produto encontrado com o Gtin informado.', info: 'warning', open: true });
  //                     }
  //                 }).catch(error => {
  //                     setProdutoSeller({
  //                         gtin: "",
  //                         nomeProduto: "",
  //                         gpc: "",
  //                         sku:"",
  //                         sellerId:"",
  //                         categoria: "",
  //                         ncm: "",
  //                         descricaoProduto: "",
  //                         produtoUrlImagem: "",
  //                         paisRegistro: "",
  //                         fabricante: "",
  //                         distribuidores: "",
  //                         marca: "",
  //                         precoMedio: 0,
  //                         descricaoNcm: "",
  //                         validade: "",
  //                         quantidadeUnidade: "",
  //                         alturaUnidade: "",
  //                         larguraUnidade: "",
  //                         profundidadeUnidade: "",
  //                         pesoBrutoUnidade: "",
  //                         pesoLiquidoUnidade: "",
  //                         volumeUnidade: "",
  //                         gtinDun14Caixa: "",
  //                         quantidadePorCaixa: "",
  //                         alturaCaixa: "",
  //                         larguraCaixa: "",
  //                         profundidadeCaixa: "",
  //                         volumeCaixa: "",
  //                         pesoBrutoCaixa: "",
  //                         pesoLiquidoCaixa: "",
  //                         quantidadeDeCaixaPorPallet: "",
  //                         alturaPallet: "",
  //                         larguraPallet: "",
  //                         profundidadePallet: "",
  //                         pesoBrutoPallet: "",
  //                         pesoLiquidoPallet: "",
  //                         volumePallet: ""
  //                     });

  //                     setNovoProduto(true);
  //                     addSnackBar({ message: 'Erro ao tentar obter detalhes do produto por Gtin', info: 'error', open: true });
  //                     setBuscaPorGtin(false);
  //                 })
  //         )
  //     }
  // }
  const buscarDadosPorGtin = (event) => {
    let value = event.target.value;
    var filtroIdEmpresa = idEmpresa;
    var profile = services.storage.get("authSistema");

    if (!idEmpresa && profile?.idSeller) {
      filtroIdEmpresa = profile.idSeller;
    }

    if (event.code === "Enter" || event.code === "Tab" || event.key === "Tab") {
      setNovoProduto(false);
      trackPromise(
        buscarDadosProdutoSellerGtin(value, filtroIdEmpresa)
          .then((res) => {
            if (res.data) {
              validarCampoNaoSeAplica(res.data);
              setNovoProduto(false);
              setBuscaPorGtin(true);
              setProdutoSeller(res.data);
              setModal(false);
              document.querySelector("#sku-field").focus();
            } else {
              setNovoProduto(true);
              setBuscaPorGtin(false);
              setModal(true);
              // Exibir mensagem de alerta com opções
              // if (window.confirm('Produto não localizado na Simplus. Deseja realizar o cadastro manual?')) {
              //     // Direcionar foco para o próximo campo SKU
              //     document.querySelector('#sku-field').focus();
              // } else {
              //     // Limpar campo GTIN e direcionar foco para ele
              //     setProdutoSeller(prev => ({ ...prev, gtin: '' }));
              //     document.querySelector('#gtin-field').focus();
              // }
            }
          })
          .catch((error) => {
            setProdutoSeller({
              gtin: "",
              nomeProduto: "",
              gpc: "",
              sku: "",
              sellerId: "",
              categoria: "",
              ncm: "",
              dataAtualizacao: "",
              descricaoProduto: "",
              produtoUrlImagem: "",
              paisRegistro: "",
              fabricante: "",
              distribuidores: "",
              marca: "",
              precoMedio: 0,
              descricaoNcm: "",
              validade: "",
              quantidadeUnidade: "",
              alturaUnidade: "",
              larguraUnidade: "",
              profundidadeUnidade: "",
              pesoBrutoUnidade: "",
              pesoLiquidoUnidade: "",
              volumeUnidade: "",
              gtinDun14Caixa: "",
              quantidadePorCaixa: "",
              alturaCaixa: "",
              larguraCaixa: "",
              profundidadeCaixa: "",
              volumeCaixa: "",
              pesoBrutoCaixa: "",
              pesoLiquidoCaixa: "",
              quantidadeDeCaixaPorPallet: "",
              alturaPallet: "",
              larguraPallet: "",
              profundidadePallet: "",
              pesoBrutoPallet: "",
              pesoLiquidoPallet: "",
              volumePallet: "",
            });
            setNovoProduto(true);
            addSnackBar({
              message: "Erro ao tentar obter detalhes do produto por Gtin",
              info: "error",
              open: true,
            });
            setBuscaPorGtin(false);
          })
      );
    }
  };

  return (
    <div className="ml-1 mt20">
      {modalVerificacaoEanSeller && (
        <div
          style={{
            position: "fixed",
            zIndex: 1000,
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "#fefefe",
              margin: "15% auto",
              padding: "20px",
              border: "1px solid #888",
              width: "30%",
            }}
          >
            <div>EAN já cadastrado para o Seller, deseja alterar?</div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
              <button
                className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green"
                onClick={() => {
                  document.querySelector("#sku-field").focus();
                  setModalVerificacaoEanSeller(false);
                  uploadImagem(idProdutoApiSeller);
                }}
              >
                Sim
              </button>
              <button
                className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
                onClick={() => {
                  document.querySelector("#gtin-field").focus();
                  setModalVerificacaoEanSeller(false);
                }}
              >
                Não
              </button>
            </div>
          </div>
        </div>
      )}
      {modal && (
        <div
          className="modal"
          style={{
            display: modal ? "block" : "none",
            position: "fixed",
            zIndex: 1000,
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "#fefefe",
              margin: "15% auto",
              padding: "20px",
              border: "1px solid #888",
              width: "30%",
            }}
          >
            <div>
              Produto não localizado na Simplus. Deseja realizar o cadastro
              manual?
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
              <button
                className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green"
                onClick={() => {
                  document.querySelector("#sku-field").focus();
                  setModal(false);
                }}
              >
                Sim
              </button>
              <button
                className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
                onClick={() => {
                  setProdutoSeller((prev) => ({ ...prev, gtin: "" }));
                  document.querySelector("#gtin-field").focus();
                  setModal(false);
                }}
              >
                Não
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="row mt-1">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <span className="titulo">Produtos</span>
          {id != null && produtoSeller?.dataAtualizacao != null && (
            <span className="">
              Data/Hora da última alteração:{" "}
              {produtoSeller?.dataAtualizacao
                ? new Date(produtoSeller?.dataAtualizacao).toLocaleDateString(
                    "pt-BR"
                  )
                : ""}
            </span>
          )}
        </div>
        <h1 className="col-12 sub-titulo">{id ? "Detalhe" : "Novo"}</h1>
      </div>

      <div className="row">
        {" "}
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <strong>Dados do Produto</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-7 col-md-7 col-lg-7">
              <FormControl>
                {/* <TextField
                                    required
                                    label="GTIN/EAN(Código de Barras)"
                                    inputProps={{ maxLength: 14, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onKeyPress={event => buscarDadosPorGtin(event)}
                                    onChange={event => changesProduto(event.target.value, 'gtin')}
                                    value={produtoSeller?.gtin || ''}
                                    helperText={isFormInvalid && !produtoSeller?.gtin && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.gtin ? true : false}
                                />
                                 */}
                <TextField
                  required
                  id="gtin-field"
                  label="GTIN/EAN(Código de Barras)"
                  inputProps={{ maxLength: 14, style: { color: "black" } }}
                  type="text"
                  size="small"
                  variant="outlined"
                  onKeyDown={(event) => {
                    if (event.key === "Tab" || event.key === "Enter") {
                      event.preventDefault();
                    }
                    buscarDadosPorGtin(event);
                  }}
                  onChange={(event) =>
                    changesProduto(event.target.value, "gtin")
                  }
                  value={produtoSeller?.gtin || ""}
                  helperText={
                    isFormInvalid && !produtoSeller?.gtin && "Campo obrigatório"
                  }
                  error={isFormInvalid && !produtoSeller?.gtin}
                />
              </FormControl>
            </div>
            <div className="col-sm-5 col-md-5 col-lg-5">
              <FormControl>
                {/* <TextField
                                    required
                                    label="SKU"
                                    inputProps={{ maxLength: 14, style: { color: 'black' } }}
                                    type="text"
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={event => changesProduto(event.target.value, 'sku')}
                                    value={produtoSeller?.sku || ''}
                                    helperText={isFormInvalid && !produtoSeller?.sku && 'Campo obrigatório'}
                                    error={isFormInvalid && !produtoSeller?.sku ? true : false}
                                /> */}
                <TextField
                  id="sku-field"
                  label="SKU"
                  inputProps={{ maxLength: 14, style: { color: "black" } }}
                  type="text"
                  size="small"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "sku")
                  }
                  value={produtoSeller?.sku || ""}
                />
              </FormControl>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <CardActionArea tabIndex={-1}>
                <img
                  width="100%"
                  src={selectedFile ?? produtoSeller?.produtoUrlImagem}
                  tabIndex={-1}
                />
              </CardActionArea>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <CardContent>
                {showEmptyImage()}
                <Grid container justify="center" alignItems="center">
                  <input
                    accept="image/*"
                    className="d-none"
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={(event) => handleUploadClick(event)}
                  />
                </Grid>
                <div className="d-flex justify-content-center">
                  <label
                    htmlFor="contained-button-file"
                    tabIndex={-1}
                    style={{ outline: "none" }}
                  >
                    <Fab component="span" tabIndex={-1}>
                      Incluir Foto
                    </Fab>
                  </label>
                </div>
              </CardContent>
            </div>
          </div>
          {((idProdutoSeller != null && atualizarProduto) ||
            idProdutoSeller == null) && <></>}
        </div>

        <div className="col-sm-8 col-md-8 col-lg-8">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}
                  label="Descrição Curta"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="descricao-curta-field"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "nomeProduto")
                  }
                  value={produtoSeller?.nomeProduto || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}
                  label="Descrição Longa"
                  inputProps={{ maxLength: 250, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "descricaoProduto")
                  }
                  value={produtoSeller?.descricaoProduto || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}
                  label="GPC(Classificação Global de Produtos)"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "gpc")
                  }
                  value={produtoSeller?.gpc || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Categoria"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "categoria")
                  }
                  value={produtoSeller?.categoria || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}
                  label="NCM (Nomenclatura Global de Produtos)"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "ncm")
                  }
                  value={produtoSeller?.ncm || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Descrição NCM"
                  inputProps={{ maxLength: 550, style: { color: "black" } }}
                  type="text"
                  multiline={true}
                  size="medium"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) => {
                    changesProduto(event.target.value, "descricaoNcm");
                  }}
                  value={produtoSeller?.descricaoNcm || ""}
                />
              </FormControl>
            </div>
          </div>
          {/*
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <FormControl>
                                <TextField
                                    
                                    label="Observação"
                                    inputProps={{ maxLength: 250 }}
                                    multiline
                                    rows={7}
                                    rowsMax={7}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={event => changesProduto(event.target.value, 'descricaoProduto')}
                                    value={produtoSeller?.descricaoProduto || ''}
                                
                                />
                            </FormControl>
                        </div>
                    </div>
                    */}
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <FormControl>
                <Autocomplete
                  className="select"
                  id="seller"
                  value={
                    produtoSeller?.sellerId
                      ? empresas.find((s) => s.id === produtoSeller?.sellerId)
                      : null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      changesSeller(newValue.id, "sellerId");
                    }
                  }}
                  options={empresas}
                  getOptionLabel={(option) =>
                    `${option.dadosCadastrais?.cnpj} - ${option.dadosCadastrais?.nomeFantasia}`
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Seller*" variant="outlined" />
                  )}
                />
              </FormControl>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Marca"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "marca")
                  }
                  value={produtoSeller?.marca || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Validade"
                  type="text"
                  size="small"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "validade")
                  }
                  value={produtoSeller?.validade}
                />
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {" "}
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <strong>Precificação</strong>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <FormControl>
                <TextField
                  label="Preço Médio Varejo"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) => {
                    const valor = event.target.value.replace(/[^\d]/g, ""); // Remove caracteres não numéricos
                    const valorFormatado = `R$ ${(
                      Number(valor) / 100
                    ).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`;
                    changesProduto(valorFormatado, "precoMedio");
                  }}
                  value={
                    produtoSeller?.precoMedio?.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    }) || "R$ 0,00"
                  } // Valor inicial com R$
                />
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {" "}
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <strong>Dados Logísticos</strong>
        </div>
      </div>

      <div className="row">
        {" "}
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <strong>Unidade</strong>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Quantidade"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "quantidadeUnidade")
                  }
                  value={produtoSeller?.quantidadeUnidade || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Altura"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "alturaUnidade")
                  }
                  value={produtoSeller?.alturaUnidade || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Largura"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "larguraUnidade")
                  }
                  value={produtoSeller?.larguraUnidade || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Profundidade"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "profundidadeUnidade")
                  }
                  value={produtoSeller?.profundidadeUnidade || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*  //disabled={!novoProduto} */

                  label="Peso Bruto"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "pesoBrutoUnidade")
                  }
                  value={produtoSeller?.pesoBrutoUnidade || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Peso Líquido"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "pesoLiquidoUnidade")
                  }
                  value={produtoSeller?.pesoLiquidoUnidade || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Volume"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "volumeUnidade")
                  }
                  value={produtoSeller?.volumeUnidade || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3"></div>
          </div>
        </div>
      </div>
      <div className="row">
        {" "}
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <strong>Caixa</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="GTIN/DUN-14"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "gtinDun14Caixa")
                  }
                  value={produtoSeller?.gtinDun14Caixa || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Quantidade por Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "quantidadePorCaixa")
                  }
                  value={produtoSeller?.quantidadePorCaixa || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Altura da Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "alturaCaixa")
                  }
                  value={produtoSeller?.alturaCaixa || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*  //disabled={!novoProduto} */

                  label="Largura da Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "larguraCaixa")
                  }
                  value={produtoSeller?.larguraCaixa || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  ////disabled={!novoProduto}

                  label="Profundidade da Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "profundidadeCaixa")
                  }
                  value={produtoSeller?.profundidadeCaixa || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*   //disabled={!novoProduto} */

                  label="Volume da Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "volumeCaixa")
                  }
                  value={produtoSeller?.volumeCaixa || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Peso Bruto por Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "pesoBrutoCaixa")
                  }
                  value={produtoSeller?.pesoBrutoCaixa || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*  //disabled={!novoProduto} */

                  label="Peso Líquido por Caixa"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "pesoLiquidoCaixa")
                  }
                  value={produtoSeller?.pesoLiquidoCaixa || ""}
                />
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {" "}
        <div className="col-sm-12 col-md-12 col-lg-12 font">
          <strong>Paletização</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*   //disabled={!novoProduto} */

                  label="Qtde. de caixas por pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(
                      event.target.value,
                      "quantidadeDeCaixaPorPallet"
                    )
                  }
                  value={produtoSeller?.quantidadeDeCaixaPorPallet || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  //disabled={!novoProduto}

                  label="Altura do pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "alturaPallet")
                  }
                  value={produtoSeller?.alturaPallet || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /* //disabled={!novoProduto} */

                  label="Largura do pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "larguraPallet")
                  }
                  value={produtoSeller?.larguraPallet || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*  //disabled={!novoProduto} */

                  label="Profundidade do pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "profundidadePallet")
                  }
                  value={produtoSeller?.profundidadePallet || ""}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  ////disabled={!novoProduto}
                  label="Peso bruto do pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "pesoBrutoPallet")
                  }
                  value={produtoSeller?.pesoBrutoPallet || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*  //disabled={!novoProduto} */

                  label="Peso liquido do pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "pesoLiquidoPallet")
                  }
                  value={produtoSeller?.pesoLiquidoPallet || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3">
              <FormControl>
                <TextField
                  /*    //disabled={!novoProduto} */

                  label="Volume do pallet"
                  inputProps={{ maxLength: 50, style: { color: "black" } }}
                  type="text"
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(event) =>
                    changesProduto(event.target.value, "volumePallet")
                  }
                  value={produtoSeller?.volumePallet || ""}
                />
              </FormControl>
            </div>
            <div className="col-sm-3 col-md-3 col-lg-3"></div>
          </div>
        </div>
      </div>

      {/*  <div className="col-sm-12 col-md-12 col-lg-12 mt-5 flex flex-end buttons">
                <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={uploadImagem}>SALVAR</button>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(3)}>CANCELAR</button>
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarProduto}>INATIVAR</button>
            </div> */}

      {idProdutoSeller && atualizarProduto && (
        <div className="mt-5">
          <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
            <button
              className="col-sm-6 col-md-6 col-lg-6 buton-green"
              onClick={() => uploadImagem()}
              style={{ opacity: isFormValid ? 1 : 0.5 }}
              disabled={!isFormValid}
            >
              SALVAR
            </button>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
            <button
              className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
              onClick={() => voltar(4)}
            >
              CANCELAR
            </button>
            {/* <ButtonYesNo
              buttonText="EXCLUIR PRODUTO"
              buttonClass="col-sm-3 col-md-3 col-lg-3 mt20 buton-red"
              alertTitle="Confirmar Exclusão"
              alertDescription="Tem certeza que deseja excluir este produto? Esta ação não pode ser desfeita."
              onConfirm={excluirProduto}
            /> */}
            {/* {produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarProduto} >INATIVAR</button>}
                        {!produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarProduto}  >ATIVAR</button>} */}
          </div>
        </div>
      )}

      {idProdutoSeller && !atualizarProduto && (
        <div className="mt-5">
          <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
            <button
              className="col-sm-6 col-md-6 col-lg-6 buton-green"
              onClick={atualizarProdutoSimplus}
            >
              REPROCESSAR INTEGRAÇÃO SIMPLUS
            </button>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
            <button
              className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
              onClick={() => voltar(4)}
            >
              CANCELAR
            </button>
            <button
              className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green"
              onClick={() => uploadImagem()}
              style={{ opacity: isFormValid ? 1 : 0.5 }}
              disabled={!isFormValid}
            >
              SALVAR
            </button>
            {produtoSeller?.ativo && (
              <button
                className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border"
                onClick={inativarProduto}
              >
                INATIVAR
              </button>
            )}
            <ButtonYesNo
              buttonText="EXCLUIR PRODUTO"
              buttonClass="col-sm-3 col-md-3 col-lg-3 mt20 buton-red"
              alertTitle="Confirmar Exclusão"
              alertDescription="Tem certeza que deseja excluir este produto? Esta ação não pode ser desfeita."
              onConfirm={excluirProduto}
            />
            {/* {produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarProduto} >INATIVAR</button>}
                        {!produtoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarProduto}  >ATIVAR</button>} */}
          </div>
        </div>
      )}

      {idProdutoSeller == null && (
        <div className="mt-5">
          <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
            <button
              className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
              onClick={() => voltar(4)}
            >
              CANCELAR
            </button>
            <button
              className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green"
              onClick={() => {
                fnVerificarEanSeller(
                  produtoSeller?.sellerId,
                  produtoSeller?.gtin,
                  produtoSeller?.sku
                );
              }}
              style={{ opacity: isFormValid ? 1 : 0.5 }}
              disabled={!isFormValid}
            >
              SALVAR
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PerfilSellerProdutoForm;
